import { Typography } from '@mui/material';
import React from 'react';
import { exchangeRates } from 'src/const';
import { convertCurrency, formatCurrency } from 'src/utils/functions';

const CustomProgressBarWithFixedDataInBetween = ({
  bgcolor,
  progress,
  height,
  displayText,
  isDisabled
}: {
  bgcolor: string;
  progress: number;
  height: string;
  displayText: string;
  isDisabled: boolean
}) => {
  const Parentdiv: React.CSSProperties = {
    height: height,
    width: '100%',
    backgroundColor: 'lightgray',
    borderRadius: '40px',
  };

  const LoadedDiv: React.CSSProperties = {
    height: '100%',
    width: `${progress}%`,
    backgroundColor: bgcolor,
    textAlign: 'center' as const,
    position: 'relative',
    borderRadius: progress !== 100 ? '10px 0px 0px 10px' : '10px',
  };

  return (
    <div style={Parentdiv}>
      <div style={LoadedDiv}></div>
      <Typography
        variant="body2"
        style={{
          color: progress>50? "white" : "black",
          fontWeight: '900',
          position: 'relative',
          top: '-20px',
          left: '64px',
          paddingTop:'1px'
        }}
      >
        {!isDisabled ? displayText: ''}
      </Typography>
    </div>
  );
};

export default CustomProgressBarWithFixedDataInBetween;
